import { render, staticRenderFns } from "./LayoutPublic.vue?vue&type=template&id=460834ef&"
import script from "./LayoutPublic.vue?vue&type=script&lang=js&"
export * from "./LayoutPublic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports